import React from 'react';
import { Box, useTheme } from '@mui/material';
import {
  AMBIENT_BASE_DARK,
  AMBIENT_GLOW_DARK,
  AMBIENT_GLOW_LIGHT,
  AMBIENT_NOISE_TEXTURE,
  BASE_LIGHT_GRADIENT,
} from '../utils/colors';

/**
 * Full-viewport ambient: AMBIENT_GLOW_DARK + AMBIENT_BASE_DARK (dark), then noise.
 */
function AmbientBackground() {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  const glowStack = isDark
    ? `${AMBIENT_GLOW_DARK}, ${AMBIENT_BASE_DARK}`
    : `${AMBIENT_GLOW_LIGHT}, ${BASE_LIGHT_GRADIENT}`;

  return (
    <Box
      aria-hidden
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 0,
        pointerEvents: 'none',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background: glowStack,
          backgroundBlendMode: 'screen',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          backgroundImage: AMBIENT_NOISE_TEXTURE,
          backgroundRepeat: 'repeat',
          pointerEvents: 'none',
        }}
      />
    </Box>
  );
}

export default AmbientBackground;
